import { Box, Typography } from "@mui/material";
import { BRAIN_REGION_COLORS } from "../../utils/constants";

interface BrainRegionBadgeProps {
  region: string;
  confidence?: number;
}

export default function BrainRegionBadge({ region, confidence }: BrainRegionBadgeProps) {
  const labelMap: Record<string, string> = {
    instinct: "本能脑主导",
    emotional: "情感脑主导",
    rational: "理智脑主导",
  };

  const color = BRAIN_REGION_COLORS[region] || "#7C6F5C";

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        backgroundColor: `${color}10`,
        border: `1px solid ${color}30`,
      }}
    >
      <Typography variant="caption" sx={{ color: "#A99F8E", fontWeight: 600 }}>
        脑区判定
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: color,
          }}
        />
        <Typography variant="body2" sx={{ color: "#7C6F5C", fontWeight: 600 }}>
          {labelMap[region] || region}
        </Typography>
        {confidence !== undefined && (
          <Typography variant="caption" sx={{ color: "#A99F8E" }}>
            (置信度 {Math.round(confidence)}%)
          </Typography>
        )}
      </Box>
    </Box>
  );
}
